function validationService () {
  var service = {
    validateEmail: validateEmail
  }
  return service

  function validateEmail (sEmail) {
    var rEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return rEmail.test(sEmail)
  }
}

export { validationService }
